import { render, staticRenderFns } from "./AvatarBadgeContent.vue?vue&type=template&id=1e3230f8&"
import script from "./AvatarBadgeContent.vue?vue&type=script&lang=js&"
export * from "./AvatarBadgeContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports